// Verbatim constants for the Notes module, from js/renderers-notes.js. Extracted so
// the colour list (order + values matter — see the note below) is guarded by a test;
// the module itself is DOM/execCommand interaction, verified via the harness + live.

/**
 * The foreColor swatches, in order. Ben swapped the original white + yellow for black
 * + purple once the module got a yellow post-it background — those two would have
 * picked text that all but disappears against the fill (renderers-notes.js:32). Keep
 * this list and its order exactly.
 */
export const NOTE_COLORS = ["#000000", "#e2586b", "#f5a623", "#7b3fe4", "#2ecc71", "#4d8bf5"] as const;

/** How long the dummy "Saved ✓" confirmation shows before reverting (renderers-notes.js:109). */
export const SAVE_FLASH_MS = 1200;
